import {
  fetchSetAllNotificationIsRead,
  fetchSetNotificationIsRead,
} from 'domains/notification/reducer';
import { useState, useRef, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatchApp } from 'redux/rootSelectors';
import { fetchMassCreativeAddTask } from 'domains/creative/reduser';
import { useNotificationMessages } from 'domains/notification/selectors';
import { INotificationPanelData } from '../types';
import { useNotificationChannelSync } from './useNotificationChannelSync';

export const useNotificationPanel = (): INotificationPanelData => {
  const { t } = useTranslation();
  const { data: notificationMessages } = useNotificationMessages();
  useNotificationChannelSync();

  const [open, setOpen] = useState(false);
  const [openTaskModal, setOpenTaskModal] = useState(false);

  const buttonRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatchApp();

  const handleGetTask = useCallback(
    (task_id: number) => {
      setOpenTaskModal(true);
      dispatch(fetchMassCreativeAddTask({ task_id }));
    },
    [dispatch],
  );

  const markAllAsRead = useCallback(() => {
    dispatch(fetchSetAllNotificationIsRead());
  }, [dispatch]);

  const markAsRead = useCallback(
    (id: number) => {
      dispatch(fetchSetNotificationIsRead({ notification_id: id }));
    },
    [dispatch],
  );

  const markAsReadAndRemove = useCallback(
    (id: number) => {
      dispatch(
        fetchSetNotificationIsRead({ notification_id: id, isRemove: true }),
      );
    },
    [dispatch],
  );

  const unreadCount = useMemo(
    () =>
      notificationMessages?.filter((notification) => !notification.is_read)
        .length ?? 0,
    [notificationMessages],
  );

  return {
    t,
    notificationMessages,
    open,
    setOpen,
    buttonRef,
    markAllAsRead,
    markAsRead,
    markAsReadAndRemove,
    handleGetTask,
    openTaskModal,
    setOpenTaskModal,
    unreadCount,
  };
};
